import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const DateBarChart = ({
  barChartDate = [],
  barChartClosedAlerts = [],
  barChartNewAlerts = [],
}) => {
  const data = {
    labels: barChartDate,
    datasets: [
      {
        label: "New Alerts",
        data: barChartNewAlerts,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
        barThickness: 60,
      },
      {
        label: "Closed Alerts",
        data: barChartClosedAlerts,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
        barThickness: 60,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        grid: {
          display: true, // 👈 removes the vertical center line
        },
      },
      y: {
        grid: {
          drawBorder: false,
        },
        border: {
          display: false, // 👈 Chart.js v3+ (extra safe)
        },
      },
    },
  };

  return (
    <div className="d-flex ac-jc" style={{ height: "300px", width: "100%" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default DateBarChart;
